<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="100px" class="approveForm">
                <el-row>
                    <el-form-item label="启用状态">
                        <el-select v-model="params.status" clearable>
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            </div>
        </div>
        
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增角色</el-button>
        </div>
       
        <el-table border :data="tableData" class="table-show-current" highlight-current-row @row-dblclick="openUpdate">
            <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
            <el-table-column prop="name" label="名称" align="center"></el-table-column>
            <el-table-column prop="initUrl" label="默认访问路径" align="center"></el-table-column>
            <el-table-column prop="status" label="启用状态" align="center">
                <template slot-scope="scope">{{statusMap[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column prop="comments" label="描述" align="center"></el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="150"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-key"v-if="scope.row.userType != 'SUPER_USER'"@click="openRoleMenu(scope.row)">分配菜单</el-button>
                    <!-- 
                    <el-button type="text" icon="el-icon-key" v-if="scope.row.userType != 'SUPER_USER'" @click="openRoleApi(scope.row)">分配资源</el-button>
                    -->
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="pageTotal"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" class="abow_dialog">
            <el-form ref="formRef" :rules="rules" :model="form" label-width="150px" class="approveForm">
                <el-row>
                    <el-form-item>
                        <div class="ps">PS: 默认访问路径 只是该角色登录系统是默认访问的页面路径，即：“菜单列表”对应的“页面路径”</div>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="名称" prop="name">
                        <el-input placeholder v-model="form.name"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="默认访问路径" prop="initUrl">
                        <el-input placeholder v-model="form.initUrl"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="启用状态" prop="status">
                        <el-select v-model="form.status">
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.comments"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">提交</el-button>
                <el-button @click="onCancel">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="给角色分配菜单" :visible.sync="roleMenuDialog" width="50%">
            <div class="custom-tree-container">
                <div class="block">
                    <el-tree :data="menuTreeData" show-checkbox node-key="id" ref="menuTree"> </el-tree>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitRoleMenu">提交</el-button>
                <el-button @click="cancelRoleMenu">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="给角色授权API" :visible.sync="roleApiDialog" width="50%">
            <div class="custom-tree-container">
                <div class="block">
                    <el-tree :data="apiTreeData" show-checkbox node-key="id" ref="apiTree"> </el-tree>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitRoleApi">提交</el-button>
                <el-button @click="cancelRoleApi">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { apiServiceApi,menuServiceApi,roleServiceApi } from '@/api/api-auth';
export default {
    name: 'lockList',
    data() {
        return {
            statusOptions:[],
            statusMap:{},
            rules: {
                name: [{ required: true, message: '不能为空' }],
                initUrl: [{ required: true, message: '不能为空' }],
                status: [{ required: true, message: '不能为空' }],
            },
            dialogVisible: false,
            dialogTitle: '新增角色',
            updateMode: false,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            params:{},
            tableData: [],
            pageTotal: 0,
            form: {},
            roleApiDialog: false,
            apiTreeData: [],
            curRoleId: null,
            defaultExpandAll: false,
            roleMenuDialog: false,
            menuTreeData: [],
            copyResourceData: [],
            copyMenuData:[],
        };
    },
    created() {
        this.statusOptions = this.findDict("yesOrNo");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        apiServiceApi.findTree().then(res => {
            this.copyResourceData = res;
        });
        menuServiceApi.findTree().then(res => {
            this.copyMenuData = res;
        });
        this.handleSearch();
    },
    methods: {
        loadNode(node, resolve) {
            if (node.level === 0) {
                return resolve(this.apiTreeData);
            }
            if (node.level > 1) return resolve([]);
            findAuthResourceList({ parentId: node.data.resourceId }).then(res => {
                resolve(res.data);
            });
        },
        // 刷新数据
        handleSearch() {
            roleServiceApi.findPageList({}, this.pageInfo).then(res => {
                this.tableData = res.records;
                this.pageTotal = res.total || 0;
            });
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        openCreate() {
            this.form = {};
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.dialogTitle = '新增角色';
            this.dialogVisible = true;
        },
        openUpdate(data) {
            this.form = JSON.parse(JSON.stringify(data));
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.dialogTitle = '修改角色';
            this.dialogVisible = true;
        },
        pickerBeginDateAfter() {
            time => {
                let beginDateVal = new Date().getTime() - 24 * 3600 * 1000;
                return time.getTime() < beginDateVal;
            };
        },
        onSubmit() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                roleServiceApi.update(this.form).then(res => {
                    if (res.result) {
                        this.$message.success('保存成功');
                        this.onCancel();
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        onCancel() {
            this.form = {};
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.dialogVisible = false;
        },
        openRoleMenu(row) {
            this.menuTreeData = this._.clone(this.copyMenuData);
            this.curRoleId = row.id;
            this.roleMenuDialog = true;
            menuServiceApi.findByRoleId({ roleId: this.curRoleId}).then(res => {
                if (res && res.length > 0) {
                    res.map((i, n) => {
                        let node = this.$refs.menuTree.getNode(i.menuId);
                        if (node && node.isLeaf) {
                            this.$refs.menuTree.setChecked(node, true);
                        }
                    });
                }
            });
        },
        submitRoleMenu() {
            let checkedNodes = this.$refs.menuTree.getCheckedNodes();
            if (!checkedNodes || checkedNodes.length == 0) {
                checkedNodes = [];
            }
            let idList = [];
            checkedNodes.forEach(it => {idList.push(it.id);});
            menuServiceApi.updateByRoleId({ roleId: this.curRoleId, menuIdList: idList }).then(res => {
                if (res.result) {
                    this.$message.success('分配菜单成功');
                    this.cancelRoleMenu();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        cancelRoleMenu() {
            this.menuTreeData = [];
            this.roleMenuDialog = false;
        },
        openRoleApi(row) {
            this.apiTreeData = this._.clone(this.copyResourceData);
            this.curRoleId = row.id;
            apiServiceApi.findByRoleId({roleId:this.curRoleId}).then(res => {
                if (res && res.length > 0) {
                    res.map((i, n) => {
                        let node = this.$refs.apiTree.getNode(i.apiId);
                        if (node && node.isLeaf) {
                            //设置某个节点的勾选状态
                            this.$refs.apiTree.setChecked(node, true);
                        }
                    });
                }
            });
            this.roleApiDialog = true;
        },
        //权限管理提交
        submitRoleApi() {
            let base_arr = this.$refs.apiTree.getCheckedNodes(false, true);
            if (!base_arr || base_arr.length == 0) {
                base_arr = [];
            }
            console.log(base_arr);
            let apiIdList = [];
            base_arr.forEach(it => {apiIdList.push(it.id);});
            apiServiceApi.updateByRoleId({roleId:this.curRoleId,apiIdList:apiIdList}).then(res => {
                if (res.result) {
                    this.$message.success('保存成功');
                    this.cancelRoleApi();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        cancelRoleApi() {
            this.apiTreeData = [];
            this.roleApiDialog = false;
        },
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.reject {
    background-color: #9b8080 !important;
}

.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-col {
    width: 50%;
}
.el-select,
.el-date-editor,
.el-input,
.el-textarea {
    width: 90%;
}
.banner {
    margin: 0px;
}
</style>
